import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { NameField } from '../../../commons/ui/fields/NameField';
import { AddMarkingToolBl } from '../../AddMarkingTool.bl';
import { IAddMarkingToolStore } from '../../AddMarkingTool.store';

export const NameFieldContainer = observer((): ReactElement => {
  const bl = useInjection(AddMarkingToolBl.$);
  const store = useInjection(IAddMarkingToolStore.$);

  const handleChange = (name: string): void => {
    bl.changeName(name);
  };

  return (
    <NameField
      changeName={handleChange}
      name={store.name}
      nameStatus={store.nameStatus}
    />
  );
});
